import {IconButton, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Form from "./form";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import Images from "../../assets";
import LanguageSelect from "../../components/app/languageSelect/languageSelect";
import LogoutIcon from "@mui/icons-material/Logout";
import React from "react";


const Verification = (props) => {
	const { t } = useTranslation(PAGE_LOGIN)

	return (
		<PageContentWrapper>
			<Box
				sx={{
					mt:0,
					pt:0,
					width: "100%",
					minHeight: "100vh",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					px: 2
				}}
			>
				<Box
					sx={{
						width: 600,
						minHeight: 440,
						display: "flex",
						flexDirection: "column",
						borderRadius: "30px",
						overflow: "hidden",
						boxShadow: "0px 40px 40px rgba(0,0,0,0.4)",
						position: "relative",
						backdropFilter: "blur(10px)"
					}}
				>
					<Box
						sx={{
							width: "100%",
							height: 108,
							background: "#FFFFFF",
							borderRadius: "30px 30px 0 0",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							boxShadow: "0px 20px 40px rgba(0,0,0,0.48)",
							zIndex: 2,
						}}
					>
						<Box
							component="img"
							src={Images.bigLogoNew}
							alt="logo"
							sx={{
								display:'flex',
								width: "50%",
								height:'50%'
							}}
						/>

							<LanguageSelect color={'#000000'}/>

					</Box>

					<Box
						sx={{
							flex: 1,
							width: "100%",
							background:
								"linear-gradient(180deg, rgba(255,255,255,0.01) 50%, rgba(216,216,216,0.01) 100%)",
							backdropFilter: "blur(10px)",
							px: 4,
							py: 5,
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							color: "#fff",
						}}
					>

						<Typography
							sx={{
								fontWeight: 700,
								fontSize: 22,
								mb: 2,
								textAlign: "center",
							}}
						>
							{t("SNF Grant Portal")} <br/>
							{t("Account Verification")}
						</Typography>
						<Form />

					</Box>
				</Box>
			</Box>
		</PageContentWrapper>
	);
};

export default Verification

